import React from 'react';
import { FundsFilters } from '../../../../app/models/Fund';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';
import { Society } from '../../../../app/models/Society';

type Props = {
    filter: FundsFilters;
    setFilter: (filter: FundsFilters) => void;
    onSearch: () => void;
    societies?: Society[];
    downloadTxt: boolean
};

const FundsRequestFilter = ({ 
    filter, 
    setFilter, 
    onSearch, 
    societies, 
    downloadTxt 
}: Props) => {

    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    const handlerSelectFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };


    return (
        
            <div className="row">
                <div className="row">

                    {downloadTxt && <div className="col-md-auto">
                        <div>
                            <label className="font-size-10 mb-1">Sociedad</label>
                            <select

                                name="society"
                                className="form-control form-control-sm"
                                value={filter.society ?? ''}
                                onChange={(e) => handlerSelectFilter(e)}
                            >
                                <option value="PEGASUS LOGISTICS LIMITADA">PEGASUS LOGISTICS LIMITADA</option>
                            </select>
                        </div>
                    </div>}

                    {!downloadTxt && <div className="col-md-auto">
                        <div>
                            <label className="font-size-10 mb-1">Sociedad</label>
                            <input
                                title="Sociedad"
                                type="text"
                                id="society"
                                name="society"
                                className="form-control form-control-sm"
                                value={filter.society ?? ''}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div>}

                    <div className="col-md-auto">
                        <div>
                            <label className="font-size-10 mb-1">Conductor</label>
                            <input
                                title="Conductor"
                                type="text"
                                id="carrier"
                                name="carrier"
                                className="form-control form-control-sm"
                                value={filter.carrier ?? ''}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div>
                    {/* <div className="col-md-auto">
                        <div>
                            <label className="font-size-10 mb-1">Fecha</label>
                            <input
                                title="Fecha de emisión"
                                type="date"
                                id="date"
                                name="date"
                                className="form-control form-control-sm"
                                value={filter.date}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div> */}

                    <div className="col-md-auto">
                        <div className="mb-3">
                            <label className="font-size-10 mb-1" htmlFor="start_date">
                                Desde
                            </label>
                            <input
                                type="date"
                                id="start_date"
                                name="start_date"
                                className="form-control form-control-sm"
                                value={filter.start_date}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div>
                    <div className="col-md-auto">
                        <div className="mb-3">
                            <label className="font-size-10 mb-1" htmlFor="end_date">
                                Hasta
                            </label>
                            <input
                                type="date"
                                id="end_date"
                                name="end_date"
                                className="form-control form-control-sm"
                                value={filter.end_date}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div>

                    <div className="col-md-auto">
                        <div>
                            <label className="font-size-10 mb-1">Motivo</label>
                            <input
                                title="Motivo"
                                type="text"
                                id="transfer_reason"
                                name="transfer_reason"
                                className="form-control form-control-sm"
                                value={filter.transfer_reason ?? ''}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div>
                    {!downloadTxt && <div className="col-md-auto">
                        <div>
                            <label className="font-size-10 mb-1">Solicitado por</label>
                            <input
                                title="created_user"
                                type="text"
                                id="created_user"
                                name="created_user"
                                className="form-control form-control-sm"
                                value={filter.created_user ?? ''}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div>}
                    { !downloadTxt && <div className="col-md-auto">
                        <div className="mb-3">
                            <label className="font-size-10 mb-1" htmlFor="quote_status">
                                Estado
                            </label>
                            <select
                                // comentar id para evitar error de estilo en el filtro.
                                // id="status"
                                name="status"
                                className="form-control form-control-sm"
                                value={filter.status ?? ''}
                                onChange={(e) => handlerSelectFilter(e)}
                            >
                                <option value="">TODOS</option>
                                <option value="DRAFT">Borrador</option>
                                <option value="REQUEST">Solicitada</option>
                                <option value="CONFIRM">Confirmada</option>
                                <option value="REJECT">Rechazada</option>
                                <option value="CANCEL">Anulada</option>
                            </select>
                        </div>
                    </div> } 
                    <div className='col-md-auto'>
                        <div style={{marginTop: '22px'}}>
                            <ButtonSearchFilter callbackSearch={onSearch}/>
                        </div>
                    </div>
                </div>
            </div>
        
    );
};

export default FundsRequestFilter;
